<template lang="pug">
#cs-root
  .d-flex.w-100.h-100
    transition(name='sidenav-transition' mode='out-in')
      SideNav(
        v-if='currentRoute && currentRoute.name !== HOME_ROUTE_NAME'
        :rootPath='ROOT_PATH'
        :navItems='NAV_ITEMS'
        :currentRoute='currentRoute'
      )
    transition(name='router-transition' mode='out-in')
      router-view.main-router

</template>

<script>
/* eslint-disable no-console, global-require */
import SideNav from '@/components/SideNav.vue';

const ROOT_PATH = '/cs';
const HOME_ROUTE_NAME = 'cs.home';

export default {
  components: {
    SideNav,
  },
  data: () => ({
    currentRoute: null,

    ROOT_PATH,
    HOME_ROUTE_NAME,
    NAV_ITEMS: [
      {
        title: 'ทำรายการขาย',
        iconSrc: require('@/assets/sidenav/cs/sidenav-item-new-order.svg'),
        to: `${ROOT_PATH}/new-order`,
      },
      {
        title: 'ดูรายการขาย',
        iconSrc: require('@/assets/sidenav/cs/sidenav-item-sale-record.svg'),
        to: `${ROOT_PATH}/sell-record`,
      },
      {
        title: 'ดูประวัติลูกค้า',
        iconSrc: require('@/assets/sidenav/cs/sidenav-item-customer-history.svg'),
        to: `${ROOT_PATH}/customer-history`,
      },
      {
        title: 'พิมพ์รายงาน',
        iconSrc: require('@/assets/sidenav/cs/sidenav-item-print.svg'),
        to: `${ROOT_PATH}/print`,
      },
      {
        title: 'ตั้งค่าบัญชีส่วนตัว',
        iconSrc: require('@/assets/sidenav/cs/sidenav-item-profile-settings.svg'),
        to: `${ROOT_PATH}/settings`,
      },
    ],
  }),
  mounted() {
    this.currentRoute = this.$route;
  },
  watch: {
    $route(to) {
      // console.log(to);
      this.currentRoute = to;
    },
  },
};
</script>

<style lang="scss">
#cs-root {
  width: 100vw;
  height: 100vh;

  .main-router {
    // overflow: scroll;
    width: calc(100vw - #{$sidenav-width});
    flex: 1;
  }
}
</style>
